// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"2ac5f6c3","450":"7eed5d5d","453":"0718c2b8","517":"51dc4cbc","629":"9a4cfb94","661":"64cdf49d"}[chunkId] + ".chunk.js";
};